<template>
  <div class="topic_info">
    <div class="title" v-if="$route.path!=='/analysis1'" >
      <div style="display: flex;flex-direction: column;gap: 8rem;flex: 3;">
        <div>
          <span style="margin-left: 24rem">
            题目分数：<span style="color: #333;font-weight: 600;">{{topic.question_score}}</span>
          </span>
          <span style="margin-left: 24rem">
            平均得分：<span style="color: #333;font-weight: 600;">{{topic.avg_score}}</span>
          </span>
          <span style="margin-left: 24rem">
            我的得分：<span style="color: #f2413a;font-weight: 600;">{{topic.user_score}}</span>
          </span>
          <div v-if="topic.auto_judge == 0">
          <!-- <span>
            排名：<span style="color: #333;font-weight: 600;">{{topic.rank}}</span>
          </span> -->
          <span v-if="parseFloat(topic.user_score) != 0" style="margin-left: 24rem">
            打败人数：<span style="color: #333;font-weight: 600;">{{topic.percent}}%</span>
          </span>
          </div>
          <div v-else>
          <span style="margin-left: 24rem">
            正确人数：<span style="color: #333;font-weight: 600;">{{topic.correct_number}}%</span>
          </span>
          <span style="margin-left: 24rem">
            错误人数：<span style="color: #333;font-weight: 600;">{{topic.error_number}}%</span>
          </span>
          </div>
        </div>
      </div>
      <div>
      <span class="right-btn">
        <div style="display: flex;flex-direction: column;align-items: center;" v-if="discuss">
        <img src="@/static/top_opertion/fatie1.png"
             @click="toPost"
             v-if="discuss"
             alt="发帖"
             title='发帖'>
             <div>发帖</div>
             </div>
              <div style="display: flex;flex-direction: column;align-items: center;">
        <img src="@/static/doPaper/jiucuo.png"
             @click="press"
             alt=""
             title='反馈'>
              <div>反馈</div>
             </div>
                <div style="display: flex;flex-direction: column;align-items: center;">
        <img src="@/static/error/收藏.png"
             @click="collect"
             alt=""
             title='收藏'>
              <div>收藏</div>
             </div>
        <!-- <img src="@/assets/top_opertion/ysc.png"
           v-if="$route.path == '/analysis' && show"
           @click="collect"
           alt=""> -->
      </span>
      </div>
    </div>
    <div class="list">

      <div class="item">
        <a-collapse v-model:activeKey="activeKey"
                    expandIconPosition="right"
                     >
          <a-collapse-panel key="1"
                            header="题目解析">
            <div class="content"
                 v-html="topic.question_explain"></div>
          </a-collapse-panel>
          <a-collapse-panel key="2"
                            header="题目答案">
            <div class="content"
                 v-html="topic.question_answer"></div>
          </a-collapse-panel>
          <a-collapse-panel key="3"
                            header="我的答案">

            <div class="content"
                            v-for="(item,index) in  images"
                            v-if="topic.auto_judge==0">

                            <a-image :src="addAllHeader(item)"
                 width="120rem"
                 height="120rem">
        </a-image>
                         </div>
            <div class="content"
            v-if="topic.auto_judge!==0"
                 v-html="topic.user_answer"></div><img v-if="topic.user_score==topic.question_score&&topic.auto_judge!==0" src="@/static/top_opertion/Vector.png" alt="">
                 <div class="content"
            v-if="topic.user_answer ==''&&topic.auto_judge!==0">无数据</div>
          </a-collapse-panel>
          <!-- <a-collapse-panel key="4"
                            header="我的评语">
            <div class="content"
            v-if="topic.comment_to_user!==''"
                 v-html="topic.comment_to_user"></div>
                   <div class="content"
            v-else>无数据</div>
          </a-collapse-panel> -->
        </a-collapse>
      </div>
    </div>
    <PressDialog ref="pressDialogRef" />
    <Collect ref="collectRef" />
    <PostForm ref="FormRef"
              title='发帖'
              type='1'
              @submit="submit"
              @cancel='cancel'
              :isDisable='true' />
  </div>
</template>

<script setup>
import { rands } from '@/utils/rand.js'
import { ref, toRefs } from '@vue/reactivity'
import { nextTick, onMounted } from 'vue'
import PressDialog from './pressDialog.vue'
import Collect from './collect.vue'
import PostForm from '@/views/dayi/components/form.vue'
import { message } from 'ant-design-vue'
import { addPost } from '@/api/post.js'
import { addHeader,addAllHeader } from '@/init/index.js'

const pData = defineProps({
  topic: {
    type: Object,
    default: () => {
      return {
        question_id: '',
        question_score: '',
        user_score: '',
      }
    }
  },
  images:{
    type: Array,
    default:  []
  },
})
let discuss = ref(1)
onMounted(() => {
  discuss.value = JSON.parse(window.localStorage.getItem('userInfo')).discuss
})
let { topic } = toRefs(pData)
let pressDialogRef = ref(null)
let collectRef = ref(null)
let FormRef = ref(null)
let activeKey = ref(['1', '2'])

// 点击反馈按钮
const press = () => {
  let form = {
    user_paper_detail_id: topic.value.user_paper_detail_id,
    category: 0,
    comment: '',
    question_id: topic.value.question_id,
    correct_type:topic.value.correct_type
  }
  pressDialogRef.value.dialogVisible = true
  pressDialogRef.value.setData(form)
}

const collect = () => {
  if (topic.has_favorite) {
    message.warning('已经收藏过啦')
    return
  }
  let form = {
    user_paper_detail_id: topic.value.user_paper_detail_id,
    tags: ''
  }
  collectRef.value.dialogVisible = true
  collectRef.value.setData(form)
}
//点击发帖按钮
const toPost = () => {
  console.log('发帖')
  let form = {
    discuss_title: '',
    discuss_content: '',
    board_id: topic.value.subject_id,
    // question_id: rands(topic.value.question_id),
    question_id: topic.value.question_id,
    discuss_image: []
  }
  nextTick(() => {
    FormRef.value.form = form
    FormRef.value.dialogVisible = true
  })
}
//发帖弹窗》提交
const submit = async () => {
  const { status } = await addPost(
    FormRef.value.form1
  )
  if (status == 200) {
    message.success('发帖成功')
    cancel()
  }

}
const cancel = () => {
  FormRef.value.dialogVisible = false
}

</script>

<style lang="scss" scoped>
.topic_info {
  .title {
    padding: 24rem 40rem;
    background: #eff8ff;
    font-size: 20rem;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size: 20rem;
      font-weight: 400;
      line-height: 30rem;
      color: #999;
    }
    .right-btn {
         display: flex;
      gap:30rem;
        color: var(--2196-f-3, #2196F3);
    }
    .right-btn img {
      width: 36rem;
      height: 36rem;
      // margin-left: 30rem;

      cursor: pointer;
    }
  }
  .list {
    margin: 30rem;
    margin-top: 0;
    font-size: 20rem;
    font-weight: 500;
    height: calc(100vh - 198rem);
    overflow-y: auto;
    .item {
      color: #333333;
      .head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 60rem;
        background: #f6f6f6;
        border-radius: 10rem;
        div {
          &:nth-child(1) {
            text-indent: 20rem;
          }
          &:nth-child(2) {
            margin-right: 30rem;
          }
        }
      }
    }
    .content {
      font-size: 20rem;
      margin: 20rem;
    }
  }
}
:deep .ant-collapse {
  border: none;
  background-color: #ffffff !important;
  font-size: 20rem;
}
:deep .ant-collapse-item {
  overflow: hidden;
}

:deep .ant-collapse-header {
  background: #f6f6f6;
  border-radius: 10rem;
}
:deep .ant-collapse > .ant-collapse-item {
  border: none;
  margin-top: 20rem;
}
:deep .ant-collapse-content {
  border-top: none;
}
:deep
  .ant-collapse
  > .ant-collapse-item
  > .ant-collapse-header
  .ant-collapse-arrow {
  font-size: 20rem;
}
</style>